import { SITE, NAV_LINKS } from "@/constants/site";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-primary-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 pt-16 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12">
          {/* Brand */}
          <div>
            <span className="font-heading text-2xl tracking-[0.18em] text-background-50 font-medium">
              DÜZBAĞ LIFE
            </span>
            <p className="mt-1 text-xs tracking-[0.28em] uppercase text-accent-400">
              {SITE.subtitle}
            </p>
            <p className="mt-5 text-sm leading-relaxed text-background-300 max-w-xs">
              Kahramanmaraş Çağlayancerit'te doğayla iç içe bungalov konaklama,
              restaurant ve wellness deneyimi.
            </p>
          </div>

          {/* Links */}
          <div>
            <h3 className="text-background-50 font-medium tracking-wide mb-4">
              Keşfet
            </h3>
            <ul className="grid grid-cols-2 gap-x-6 gap-y-2">
              {NAV_LINKS.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-background-50 font-medium tracking-wide mb-4">
              İletişim
            </h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-accent-400 mt-0.5" />
                <span className="text-background-300">
                  {SITE.addressLine1}
                  <br />
                  {SITE.addressLine2}
                </span>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-phone-line text-accent-400" />
                <a
                  href={`tel:${SITE.phoneTel}`}
                  className="text-background-300 hover:text-accent-400 transition-colors cursor-pointer"
                >
                  {SITE.phoneDisplay}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-whatsapp-line text-accent-400" />
                <a
                  href={SITE.whatsappBase}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-background-300 hover:text-accent-400 transition-colors cursor-pointer"
                >
                  WhatsApp ile yazın
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-instagram-line text-accent-400" />
                <a
                  href={SITE.instagramUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-background-300 hover:text-accent-400 transition-colors cursor-pointer"
                >
                  {SITE.instagramHandle}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400 text-center sm:text-left">
            © {year} Düzbağ Life Bungalov &amp; Restaurant. Tüm hakları saklıdır.
          </p>
          <p className="text-xs text-background-500 text-center sm:text-right">
            Çağlayancerit / Kahramanmaraş
          </p>
        </div>
      </div>
    </footer>
  );
}